import React from 'react';
import { StyledSpinner } from './Spinner.styles';

interface SpinnerProps {
  size?: number | undefined;
  filterSpinner?: boolean;
}

const Spinner: React.FC<SpinnerProps> = ({ size, filterSpinner }) => {
  return <StyledSpinner size={size} filterSpinner={filterSpinner} data-testid="spinner" />;
};

export default Spinner;
